import {handleActions} from 'redux-actions'
import * as type from './type'
import {LOCATION_CHANGE} from 'connected-react-router'

export const initialState = {
    processInstance: null,
    fetching: false,
    error: null,
    processFlowVisible: false,
    commentText: null,
    contextHasChanged: false,
    beamProcessState: {},
    validationMessageList: [],
}


export default handleActions({
    [LOCATION_CHANGE]: (state, action) => {
        return {
            ...state,
            processInstance: null,
            processFlowVisible: false,
            fetching: false,
            commentText: null,
        }
    },
    [type.PROCESS_INSTANCE_LOADED]: (state, action) => {
        const {processInstance} = action.payload
        return {
            ...state,
            processInstance,
            fetching: false,
            processFlowVisible: false,
        }
    },
    [type.FIND_PROCESS_INSTANCE_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
            processFlowVisible: false,
        }
    },
    [type.FIND_PROCESS_INSTANCE_SUCCESS]: (state, action) => {
        const {processInstance} = action.payload
        return {
            ...state,
            processInstance,
            fetching: false,
            processFlowVisible: false,
            validationMessageList: [],
        }
    },
    [type.FIND_PROCESS_INSTANCE_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            fetching: false,
            error,
            processFlowVisible: false,
        }
    },
    [type.TOGGLE_PROCESS_FLOW_VISIBILITY]: (state, action) => {
        return {
            ...state,
            processFlowVisible: !state.processFlowVisible,
        }
    },
    [type.TOGGLE_VIP_STATUS_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.TOGGLE_VIP_STATUS_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.TOGGLE_VIP_STATUS_SUCCESS]: (state, action) => {
        return {
            ...state,
            processInstance: {
                ...state.processInstance,
                vip: !state.processInstance.vip,
            },
            fetching: false,
        }
    },
    [type.TOGGLE_RUSH_STATUS_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.TOGGLE_RUSH_STATUS_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.TOGGLE_RUSH_STATUS_SUCCESS]: (state, action) => {
        return {
            ...state,
            processInstance: {
                ...state.processInstance,
                rush: !state.processInstance.rush,
            },
            fetching: false,
        }
    },
    [type.CHANGE_PROCESS_COMMENT]: (state, action) => {
        const {value} = action.payload
        return {
            ...state,
            commentText: value,
        }
    },
    [type.COMMENT_PROCESS_INSTANCE_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.COMMENT_PROCESS_INSTANCE_SUCCESS]: (state, action) => {
        const {comment} = action.payload
        return {
            ...state,
            processInstance: {
                ...state.processInstance,
                processCommentList: [
                    ...state.processInstance.processCommentList,
                    comment,
                ],
            },
            fetching: false,
            error: null,
            commentText: '',
        }
    },
    [type.COMMENT_PROCESS_INSTANCE_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },

    [type.CHANGE_PROCESS_CONTEXT]: (state, action) => {
        const {name, value} = action.payload
        return {
            ...state,
            processInstance: {
                ...state.processInstance,
                context: {
                    ...state.processInstance.context,
                    [name]: value,
                },
            },
            contextHasChanged: true,
        }
    },
    [type.SAVE_PROCESS_CONTEXT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
        }
    },
    [type.SAVE_PROCESS_CONTEXT_SUCCESS]: (state, action) => {
        return {
            ...state,
            processInstance: {
                ...state.processInstance,
                context: {
                    ...state.processInstance.context,
                    ...action.payload.context,
                },
            },
            fetching: false,
            contextHasChanged: false,
        };
    },
    [type.SAVE_PROCESS_CONTEXT_ERROR]: (state, action) => {
        return {
            ...state,
            fetching: false,
        }
    },
    [type.SET_VALIDATION_MESSAGE_LIST]: (state, action) => {
        const {validationMessageList} = action.payload
        return {
            ...state,
            validationMessageList,
        }
    },
    [type.FIRE_EVENT_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
            processFlowVisible: false,
            validationMessageList: [],
        }
    },
    [type.FIRE_EVENT_SUCCESS]: (state, action) => {
        const {processInstance} = action.payload
        return {
            ...state,
            processInstance,
            fetching: false,
            processFlowVisible: false,

        }
    },
    [type.FIRE_EVENT_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            fetching: false,
            error,
            processFlowVisible: false,
        }
    },
    [type.CHANGE_TIME_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
        }
    },
    [type.CHANGE_TIME_SUCCESS]: (state, action) => {
        const {name, value} = action.payload
        return {
            ...state,
            fetching: false,
            processInstance: {
                ...state.processInstance,
                [name]: value,
            },
        }
    },
    [type.CHANGE_TIME_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            fetching: false,
            error,
        }
    },
    [type.CHANGE_BEAM_PROCESS_STATE]: (state, action) => {
        const {name, beamProcessState} = action.payload
        return {
            ...state,
            beamProcessState: {
                [name]: beamProcessState,
            },
        }
    },
    [type.BEAM_PROCESS_INSTANCE_REQUEST]: (state, action) => {
        return {
            ...state,
            fetching: true,
            error: null,
            processFlowVisible: false,
        }
    },
    [type.BEAM_PROCESS_INSTANCE_SUCCESS]: (state, action) => {
        const {processInstance} = action.payload
        return {
            ...state,
            processInstance,
            fetching: false,
            processFlowVisible: false,

        }
    },
    [type.BEAM_PROCESS_INSTANCE_ERROR]: (state, action) => {
        const {error} = action.payload
        return {
            ...state,
            fetching: false,
            error,
            processFlowVisible: false,
        }
    },
}, initialState)



// WEBPACK FOOTER //
// ./src/modules/process/state/instance-detail/reducer.js